var map = {
	"./pc-module-catalogue-1.vue": 83613,
	"./pc-module-catalogue-2.vue": 87128,
	"./pc-module-catalogue-3.vue": 47596,
	"./pc-module-catalogue-4.vue": 84042,
	"./pc-module-catalogue-5.vue": 34119,
	"./pc-module-catalogue-6.vue": 77163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5488;